module.exports = __webpack_public_path__ + "static/img/ent-31.2b568c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-31.jpg
// module id = Gb+z
// module chunks = 51